// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"05a1acbf","634":"89635714"}[chunkId] + ".chunk.js";
};